import React, { useMemo, useState } from "react";
import InitialDataListPage from "../components/InitialDataListPage";

const CreditorMain = ({ masterList = [], name, onPageInsert, onRowSelected }) => {
  // แสดงรายการเริ่มต้นเป็น 'ใช้งาน'
  const [statusFilter, setStatusFilter] = useState("Y");

  const filteredMasterList = useMemo(() => {
    if (!Array.isArray(masterList)) return [];
    return masterList.filter((m) => String(m?.AP_Status) === String(statusFilter));
  }, [masterList, statusFilter]);

  const columns = useMemo(() => [
    {
      key: "index",
      header: "#",
      width: "5%",
      align: "center",
      render: (_item, _index, { startIndex, itemIndex }) => startIndex + itemIndex + 1,
    },
    {
      key: "AP_Code",
      header: "รหัสผู้ขาย",
      width: "12%",
      align: "start",
      render: (item) => item.AP_Code || "-",
    },
    {
      key: "AP_Name",
      header: "ชื่อผู้ขาย",
      width: "30%",
      align: "start",
      render: (item) => item.AP_Name || "-",
    },
    {
      key: "AP_Tel",
      header: "โทรศัพท์",
      width: "15%",
      align: "center",
      render: (item) => item.AP_Tel || "-",
    },
    {
      key: "AP_TaxNo",
      header: "เลขประจำตัวผู้เสียภาษี",
      width: "18%",
      align: "center",
      render: (item) => item.AP_TaxNo || "-",
    },
    {
      key: "AP_Status",
      header: "สถานะ",
      width: "10%",
      align: "center",
      render: (item) => (item.AP_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน"),
    },
    {
      key: "actions",
      header: "แก้ไข",
      width: "10%",
      align: "center",
      isAction: true,
      render: (item, _index, { triggerRowSelected }) => (
        <button
          onClick={(event) => {
            event.stopPropagation();
            triggerRowSelected(item);
          }}
          className="btn btn-sm"
          title="แก้ไข"
          style={{
            width: "32px",
            height: "32px",
            borderRadius: "8px",
            border: "none",
            backgroundColor: "#fff3e0",
            color: "#EF6C00",
            transition: "all 0.2s ease",
          }}
          onMouseOver={(event) => {
            event.currentTarget.style.backgroundColor = "#EF6C00";
            event.currentTarget.style.color = "#fff";
          }}
          onMouseOut={(event) => {
            event.currentTarget.style.backgroundColor = "#fff3e0";
            event.currentTarget.style.color = "#EF6C00";
          }}
          type="button"
        >
          <i className="fas fa-edit" />
        </button>
      ),
    },
  ], []);

  const getSearchValues = useMemo(
    () => (item) => [item?.AP_Code, item?.AP_Name, item?.AP_Tel, item?.AP_TaxNo, item?.AP_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน"],
    []
  );

  const customHeader = (
    <div className="d-flex align-items-center" style={{ width: '100%', gap: 16, flexWrap: 'nowrap' }}>
      <label className="mb-0" style={{ fontWeight: 700, fontSize: 13, marginRight: 8, minWidth: 150, whiteSpace: 'nowrap' }}>สถานะการใช้งาน</label>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 0 }}>
          <input style={{ accentColor: '#E13F57', width: 16, height: 16 }} className="form-check-input" type="radio" name="apStatusFilter" id="filterActive" value="Y" checked={statusFilter === "Y"} onChange={() => setStatusFilter("Y")} />
          <span style={{ fontSize: 14 }}>ใช้งาน</span>
        </label>

        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 0 }}>
          <input style={{ accentColor: '#E13F57', width: 16, height: 16 }} className="form-check-input" type="radio" name="apStatusFilter" id="filterInactive" value="N" checked={statusFilter === "N"} onChange={() => setStatusFilter("N")} />
          <span style={{ fontSize: 14 }}>ไม่ใช้งาน</span>
        </label>
      </div>
    </div>
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/creditor"
      data={filteredMasterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      searchPlaceholder={`ค้นหา${name || "ข้อมูลผู้ขาย"}...`}
      fieldMappings={{ no: "AP_Id" }}
      getRowId={(item) => item?.AP_Id}
      customHeader={customHeader}
    />
  );
};

export default CreditorMain;
